"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const core_1 = require("@qubic-js/core");
const persistData_1 = require("../utils/persistData");
const createCacheMiddleware = (bridge, enablePersist) => {
    const persistedData = enablePersist ? persistData_1.getPersistedData() : null;
    let cacheAddresses = (persistedData === null || persistedData === void 0 ? void 0 : persistedData.accounts) || [];
    let cacheNetwork = (persistedData === null || persistedData === void 0 ? void 0 : persistedData.chainId) || '';
    bridge.on(core_1.BridgeEvent.accountsChanged, (addresses) => {
        cacheAddresses = addresses;
        if (!enablePersist)
            return;
        if (addresses.length === 0) {
            persistData_1.clearPersistedData();
            return;
        }
        persistData_1.setPersistedData('accounts', JSON.stringify(addresses));
    });
    bridge.on(core_1.BridgeEvent.chainChanged, chainId => {
        cacheNetwork = chainId;
        if (enablePersist)
            persistData_1.setPersistedData('chainId', chainId);
    });
    bridge.on(core_1.BridgeEvent.clear, () => {
        cacheAddresses = [];
        cacheNetwork = '';
        if (enablePersist)
            persistData_1.clearPersistedData();
    });
    return (req, res, next, end) => {
        if (req.method === 'eth_accounts' && cacheAddresses.length > 0) {
            res.result = cacheAddresses;
            end();
            return;
        }
        if (req.method === 'eth_chainId' && cacheNetwork) {
            res.result = cacheNetwork;
            end();
            return;
        }
        next();
    };
};
exports.default = createCacheMiddleware;
